let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ciAVN"), load("3HU3r")]).then(() => parcelRequire('iHpDm'));